/** Prefer UHID for display; fallback to patientUniqueId. */
export function formatPatientDisplayId(patient: {
  uhid?: string | null;
  patientUniqueId?: string | null;
} | null | undefined): string {
  if (!patient) return '—';
  const uhid = patient.uhid?.trim();
  if (uhid) return uhid;
  const legacy = patient.patientUniqueId?.trim();
  if (legacy) return legacy;
  return '—';
}
